// extracted by mini-css-extract-plugin
export default {"l_ExtensionContainer_main":"ExtensionContainer_l_ExtensionContainer_main__qWHnX","extension":"ExtensionContainer_extension__wHhYm"};